// NPM Modules
import styled from 'styled-components';
// Styled Componets
export const Container = styled.div`
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 16px;
`;